import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import APICom from "../../utils/helpers/APICom";

const PauseUnPause = (props) => {

    const { loginData }  = useSelector((store) => store.login);
    const [isComponentLoading, setIsComponentLoading] = useState(true);
    const[pauseAlertDialog, setPauseAlertDialog] = useState(false);
    const[pauseAlertObj, setPauseAlertObj] = useState({alertTitle: '', alertMsg:''});
    const[pauseUnPauseObj, setPauseUnPauseObj] = useState({iRefID: '-1', ServiceID: '-1', TripState: '', iUserID:'-1', iAppID: '5'});

    useEffect(() => {
        const updateTripState = async () => {
            if(props.GridRowData === null || props.GridRowData.length <= 0)
            {
                setPauseAlertObj({...pauseAlertObj, alertTitle: 'No trip selected', alertMsg:'Please select a trip to perform pause.'});
                setPauseAlertDialog(true);
            }
            // else if(props.GridRowData.length > 1)
            // {
            //     setPauseAlertObj({...pauseAlertObj, alertTitle: 'Multiple trips selected', alertMsg:'Please select one trip to perform pause.'});
            //     setPauseAlertDialog(true);
            // }
            else
            {
                const gData = props.GridRowData;
                for(let i = 0; i < gData.length; i++ ){
                    pauseUnPauseObj["iRefID"] = gData[i].ConfirmationNo;
                    pauseUnPauseObj["ServiceID"] = (gData[i].ServiceID).toString();
                    pauseUnPauseObj["TripState"] = gData[i].TripState;
                    pauseUnPauseObj["iUserID"] = loginData.iUserID;
                    pauseUnPauseObj["iAppID"] = '26'
                    let response = await APICom.fetchData("", "TripActions/PauseUnPauseTripState", "post", { "Content-Type": "application/json" }, pauseUnPauseObj, null);
                    let result = response.data;
                }
                setPauseAlertObj({...pauseAlertObj, alertTitle: 'Success', alertMsg:'Trip state updated successfully.'});
                setPauseAlertDialog(true);
            
            }
        };

        updateTripState();
    }, []);

    useEffect(() => {
        if(isComponentLoading)
        {
          setIsComponentLoading(false);
          return;
        }
        // handlePauseUnPauseAPICall(pauseUnPauseObj);
    }, [pauseUnPauseObj]);

    const handlePauseUnPauseAPICall = async (pauseUnPauseObj) => {
        pauseUnPauseObj["iUserID"] = loginData.iUserID;
        pauseUnPauseObj["iAppID"] = '26'
        let response = await APICom.fetchData("", "TripActions/PauseUnPauseTripState", "post", { "Content-Type": "application/json" }, pauseUnPauseObj, null);
        let result = response.data;
        setPauseAlertObj({...pauseAlertObj, alertTitle: 'Success', alertMsg:'Trip state updated successfully.'});
        setPauseAlertDialog(true);
    }

    const handleAlertModalClose = () => {
        setPauseAlertDialog(false);
        UnMountPauseUnPauseComponent();
    }

    const UnMountPauseUnPauseComponent = () => {
        if(props.invokePauseUnPauseComponent)
        {
            props.setPauseProcessing(false);
            props.RefreshGridData();
            props.setPauseUnPauseComponent(false);
        }
    }

    return(
        <>
            { pauseAlertDialog && <Modal centered show={pauseAlertDialog} onHide={handleAlertModalClose} animation={false}>
                    <Modal.Header className='noshow_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>{pauseAlertObj.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><b>{pauseAlertObj.alertMsg}</b></Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Close
                    </Button>
                    </Modal.Footer>
                </Modal>}
        </>
    );
};

export default PauseUnPause;